import cloneDeep from 'clone-deep'
import type { InputType } from 'config/input.type.constants'
import { InputValidate } from 'utils'

export function validateInputRecord(data: Record<string, InputType>) {
  const d = cloneDeep(data)
  let success = true
  Object.keys(d).forEach((k) => {
    d[k].error = InputValidate(d[k])
    if (d?.[k]?.error?.length) success = false
  })
  return { data: d, success }
}
